<template>
  <div class="countdown ma-4">
    <div v-if="days" class="countdown__block">
      <div class="countdown__digit font-weight-light">{{ days | twoDigits }}</div>
      <div class="countdown__text">Días</div>
    </div>
    <div class="countdown__block">
      <div class="countdown__digit font-weight-light">{{ hours | twoDigits }}</div>
      <div class="countdown__text">Horas</div>
    </div>
    <div class="countdown__block">
      <div class="countdown__digit font-weight-light">{{ minutes | twoDigits }}</div>
      <div class="countdown__text">Min</div>
    </div>
    <div class="countdown__block">
      <div class="countdown__digit font-weight-light">{{ seconds | twoDigits }}</div>
      <div class="countdown__text">Seg</div>
    </div>
  </div>
</template>
<script>
import { DateTime } from 'luxon';

export default {
  props: {
    date: null
  },
  data () {
    const now = DateTime.now().setZone('America/Argentina/Buenos_Aires');

    return {
      now: Math.trunc(now.toMillis() / 1000),
      event: this.date,
      finish: false
    }
  },
  mounted () {
    const _self = this
    window.setInterval(() => {
      const now = DateTime.now().setZone('America/Argentina/Buenos_Aires');
      this.now = Math.trunc(now.toMillis() / 1000);
      if (!this.finish && this.calculatedDate - this.now <= 0) {
        _self.finish = true
        _self.$emit('onFinish')
      }
    }, 1000)
  },
  computed: {
    secondCount () {
      return this.calculatedDate - this.now
    },
    calculatedDate () {
      return Math.trunc(Date.parse(this.event) / 1000)
    },
    seconds () {
      if (this.secondCount < 0) return 0
      return this.secondCount % 60
    },
    minutes () {
      if (this.secondCount < 0) return 0
      return Math.trunc(this.secondCount / 60) % 60
    },
    hours () {
      if (this.secondCount < 0) return 0
      return Math.trunc(this.secondCount / 60 / 60) % 24
    },
    days () {
      if (this.secondCount < 0) return 0
      return Math.trunc(this.secondCount / 60 / 60 / 24)
    }
  },
  filters: {
    twoDigits (value) {
      if (value.toString().length <= 1) {
        return '0' + value.toString()
      }
      return value.toString()
    }
  }
}
</script>
<style lang="scss">
.countdown{
  display: flex;
  justify-content: center;
  &__block {
    text-align: center;
    padding: 0px 15px;
    position: relative;
    &:first-child{
      padding-left: 0;
      .countdown__digit{
        &:before{
          display: none;
        }
      }
    }
    &:last-child{
      padding-right: 0;
    }
  }
  &__text {
    text-transform: uppercase;
    margin-bottom: 5px;
  }
  &__digit {
    font-size: 300%;
    font-weight: bold;
    line-height: 1;
    margin-bottom: 5px;
    &:before{
      content: ":";
      position: absolute;
      left: -5px;
    }
  }
}
</style>
